exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--7-1!./node_modules/postcss-loader/lib??postcss!./src/css/positioning/base_type_config.css
// module id = ./node_modules/css-loader/index.js??ref--7-1!./node_modules/postcss-loader/lib/index.js??postcss!./src/css/positioning/base_type_config.css
// module chunks = styles